import { createAsyncActionTypes } from '../../util/createLifeomicActionTypes';

export default createAsyncActionTypes(['SEARCH_SUBJECTS']);
